import React from 'react';
import Header from './Components/Header';
import Hero from './Components/Hero';
import MainContent from './Components/MainContent';
import Footer from './Components/Footer';

export default function App(){
    return (
        <div>
            <Header />
            <Hero />
            <MainContent />
            <Footer />
        </div>
    )
}